import { FeatureCooldownType } from './types';

const FEATURE_COOLDOWN_DURATIONS: Record<FeatureCooldownType, number> = {
  [FeatureCooldownType.LifeRequest]: 30 * 60 * 1000,
};

export function getFeatureCooldownTime(feature: FeatureCooldownType): number {
  return Date.now() + FEATURE_COOLDOWN_DURATIONS[feature];
}
